export const comments_5588991 = {"data":{"data":[],"links":{}}}